<template>
  <vx-card :title="title">
        <h6>
          Bet : {{ loading(currency(sumAmount)) }}
        </h6>
        <br />
        <h6>
          Win/Lose :
          <span
            :class="
              sumWinLose > 0
                ? 'text-success'
                : 'text-danger'
            "
          >
            {{ loading(currency(sumWinLose)) }}
          </span>
        </h6>
        <br />
        <h6>
          Rolling :
          {{ loading(currency(sumRolling)) }}
        </h6>
      </vx-card>
</template>

<script>
export default {
  name: 'ResultCard',
  props: {
    title: {
      type: String,
      required: true
    },
    sumAmount: {
      type: Number,
      required: true
    },
    sumWinLose: {
      type: Number,
      required: true
    },
    sumRolling: {
      type: Number,
      required: true
    }
  },
  methods: {
    loading (data) {
      if (this.isLoading) return ''
      else return data
    },
    currency (amount) {
      amount = (amount * 1.0).toFixed(2)
      //SET NULL OR NaN = 0
      if (!amount || amount === 'NaN') {
        amount = 0
      }
      if (amount >= 0) {
        if (typeof amount === 'number') {
          amount = String(Math.abs(amount))
        }
        return amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')
      } else {
        amount = String(amount)
        //return `-${(amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
        return amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')
      }
    }
  }
}
</script>
